import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const sections = [
  {
    title: 'Pilot Disclaimer',
    body:
      'This platform is currently operating in pilot mode. Features, offers, and rewards may change, be updated, or be withdrawn at any time without notice. We are continuously testing and improving the experience.',
  },
  {
    title: 'Offers Disclaimer',
    body:
      'All offers, discounts, and prize draws are provided by third-party partners and are subject to availability and change. We do not guarantee the availability, accuracy, or fulfillment of any offer. Terms set by each partner may apply.',
  },
  {
    title: 'Verification',
    body:
      'Users may be required to provide evidence to verify certain actions. We reserve the right to review, approve, or reject submissions at our discretion.',
  },
  {
    title: 'Liability',
    body:
      'To the maximum extent permitted by law, we are not liable for any loss or damage arising from the use of this platform or participation in offers.',
  },
  {
    title: 'Environmental Commitment',
    body:
      'We are committed to contributing a portion of future proceeds to environmental causes as part of our mission. Details of this commitment may evolve as the platform grows.',
  },
];

const Terms = () => (
  <div className="min-h-screen bg-gray-50">
    <div className="max-w-md mx-auto min-h-screen bg-gray-50 px-4 py-8 pb-12">
      <Link
        to="/"
        className="inline-flex items-center gap-1.5 text-sm text-gray-600 hover:text-green-700 mb-6"
      >
        <ArrowLeft className="h-4 w-4" />
        Back
      </Link>

      <h1 className="text-2xl font-bold text-gray-900 tracking-tight">Terms & Conditions</h1>
      <p className="text-sm text-gray-500 mt-2 mb-8">Last updated for pilot release</p>

      <div className="space-y-8">
        {sections.map(({ title, body }) => (
          <section key={title}>
            <h2 className="text-sm font-semibold text-gray-900 uppercase tracking-wide mb-2">
              {title}
            </h2>
            <p className="text-sm text-gray-600 leading-relaxed">{body}</p>
          </section>
        ))}
      </div>
    </div>
  </div>
);

export default Terms;
